import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClientAccess from "@/pages/ClientAccess";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCategoryDetail from "@/pages/AdminCategoryDetail";
import FeedbackConversation from "@/pages/FeedbackConversation";

function App() {
  return (
    <div className="min-h-screen bg-background grid-bg">
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ClientAccess />} />
          <Route path="/project/:categoryId" element={<ClientDashboard />} />
          <Route path="/webo0os" element={<AdminLogin />} />
          <Route path="/webo0os/dashboard" element={<AdminDashboard />} />
          <Route path="/webo0os/category/:categoryId" element={<AdminCategoryDetail />} />
          <Route path="/feedback/:token" element={<FeedbackConversation />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
